import { resolveContentBlocks } from '@/utils/resolvers';
import React, { useRef } from 'react';
import CMSWrapper from '../shared/CMSWrapper';
import Dashboard from './Dashboard';

const DashboardMapper = ({ content, contentButtons, presentation = {} }: any) => {
  const { bottomSpacing, topSpacing } = presentation;

  return (
    <div
      data-datalayer-position="dashboard"
      data-datalayer-variant={presentation?.datalayerVariant}
    >
      <Dashboard
        {...content}
        bottomSpacing={bottomSpacing}
        topSpacing={topSpacing}
        contentButtons={contentButtons}
      />
    </div>
  );
};

const DashboardCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        contentBlocks: ['detailContent', resolveContentBlocks],
      },
    ],
    componentParameterMap: [
      'presentation',
      {
        'variant-label': 'datalayerVariant',
        'bottom-spacing': 'bottomSpacing',
        'top-spacing': 'topSpacing',
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Dashboard Content</b> required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={DashboardMapper}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default DashboardCMSWrapper;
